import { apiClient } from "../../base/ApiClient";

export const createEnvironmentalRiskAssessment = async (formData) => {
  const response = await apiClient.post("/client/risk-assessments/", formData);
  return response;
};

export const deleteEnvironmentalRiskAssessment = async (riskAssessmentId) => {
  const response = await apiClient.delete(
    `/client/risk-assessments/${riskAssessmentId}/`
  );
  return response;
};

export const getClientEnvironmentalRiskAssessment = async (clientId) => {
  const response = await apiClient.get(
    `/client/risk-assessments/?client_id=${clientId}`
  );
  return response.data;
};

export const getEnvironmentalQuestions = async () => {
  const response = await apiClient.get(`/client/risk-questions/`);
  return response.data;
};

export const createEnvironmentalQuestion = async (formData) => {
  const response = await apiClient.post("/client/risk-questions/", formData);
  return response;
};

export const editEnvironmentalQuestion = async (id, formData) => {
  const response = await apiClient.put(
    `/client/risk-questions/${id}/`,
    formData
  );
  return response.data;
};

export const deleteEnvironmentalQuestion = async (id) => {
  const response = await apiClient.delete(`/client/risk-questions/${id}/`);
  return response;
};
export const getEnvironmentalQuestionById = async (id) => {
  const response = await apiClient.get(`/client/risk-questions/${id}/`);
  return response.data;
};

export const getAbbeyPainScales = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/abbey-pain-scale/list/?client_id=${clientId}`
  );
  return response.data;
};
export const createAbbeyPainScale = async (formData) => {
  const response = await apiClient.post(
    "/assessments/abbey-pain-scale/create/",
    formData
  );
  return response.data;
};
export const getCapabilityAssessment = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/capability-assessment/list/?client_id=${clientId}`
  );
  return response.data;
};
export const createCapability = async (formData) => {
  const response = await apiClient.post(
    "/assessments/capability-assessment/create/",
    formData
  );
  return response.data;
};

export const getChokingAssessments = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/choking-assessments/?client_id=${clientId}`
  );
  return response.data;
};
export const createChokingAssessment = async (formData) => {
  const response = await apiClient.post(
    `/assessments/choking-assessments/`,
    formData
  );
  return response.data;
};
export const getCornelDepression = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/cornel-depression/?client_id=${clientId}`
  );
  return response.data;
};
export const createCornelDepression = async (formData) => {
  const response = await apiClient.post(
    `/assessments/cornel-depression/`,
    formData
  );
  return response.data;
};
export const getGeriatricDepressionScales = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/geriatric-depression/?client_id=${clientId}`
  );
  return response.data;
};
export const createGeriatricDepressionScale = async (formData) => {
  const response = await apiClient.post(
    `/assessments/geriatric-depression/`,
    formData
  );
  return response.data;
};
export const getFallsRiskAssessments = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/fall-tools/?client_id=${clientId}`
  );
  return response.data;
};
export const createFallsRiskAssessment = async (formData) => {
  const response = await apiClient.post(`/assessments/fall-tools/`, formData);
  return response.data;
};
export const getFireRiskAssessments = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/fire-risk/?client_id=${clientId}`
  );
  return response.data;
};
export const createFireRiskAssessment = async (formData) => {
  const response = await apiClient.post(`/assessments/fire-risk/`, formData);
  return response.data;
};
export const getInitialOralHealthAssessments = async (clientId) => {
  const response = await apiClient.get(
    `/assessments/oral-health/?client_id=${clientId}`
  );
  return response.data;
};
export const createInitialOralHealthAssessment = async (formData) => {
  const response = await apiClient.post(`/assessments/oral-health/`, formData);
  return response.data;
};
